import React from "react";
import { StyledTabPanel } from "pages/InterviewManagement/InterviewList/TabPanel/styled";

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <StyledTabPanel
      role="tabpanel"
      hidden={value !== index}
      id={`interview-tabpanel-${index}`}
      aria-labelledby={`interview-tab-${index}`}
    >
      {value === index && children}
    </StyledTabPanel>
  );
};
